module.exports = __webpack_public_path__ + "img/service.162ae230.png";